export const getFinanceParams = (label: string, params: any) => {
  const labelLower = label.toLowerCase();
  const now = new Date();

  if (labelLower === 'daily') {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.tag_id = 102281;
    params.archived = false;
    params.exclude_tag_id = 21;
  } else if (labelLower === 'weekly') {
    const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    params.end_date_min = weekAgo.toISOString();
    params.ascending = false;
    params.tag_id = 120;
    params.archived = false;
    params.exclude_tag_id = 21;
    params.limit = 100;
    params.recurrence = 'weekly';
  } else if (labelLower === 'monthly') {
    const monthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    params.end_date_min = monthAgo.toISOString();
    params.ascending = false;
    params.tag_id = 120;
    params.archived = false;
    params.exclude_tag_id = 21;
    params.limit = 100;
    params.recurrence = 'monthly';
  } else if (labelLower.includes('stocks')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 102676;
  } else if (labelLower.includes('earnings')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
  } else if (labelLower.includes('indices')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 102682;
  } else if (labelLower.includes('commodities')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 101031;
  } else if (labelLower.includes('forex')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 101705;
  } else if (labelLower.includes('acquisitions')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 102691;
  } else if (labelLower.includes('earnings calls')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
    params.tag_id = 102451;
  } else if (labelLower.includes('ipos')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
  } else if (labelLower.includes('fed rates')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
  } else if (labelLower.includes('prediction markets')) {
    const today = new Date();
    params.end_date_min = today.toISOString();
    params.ascending = false;
    params.archived = false;
  }
  return params;
};

export const getCryptoParams = (label: string, params: any) => {
  const labelLower = label.toLowerCase();
  const now = new Date();
  if (labelLower === 'daily') {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    params.end_date_min = today.toISOString();
  } else if (labelLower === 'weekly') {
    const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    params.end_date_min = weekAgo.toISOString();
    params.range = 'weekly';
  } else if (labelLower === 'monthly') {
    const monthAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    params.end_date_min = monthAgo.toISOString();
    params.range = 'monthly';
  } else if (labelLower.includes('15 min') || labelLower.includes('15m')) {
    const fifteenMinAgo = new Date(now.getTime() - 15 * 60 * 1000);
    params.end_date_min = fifteenMinAgo.toISOString();
    params.limit = 10;
  } else if (labelLower.includes('5 min') || labelLower.includes('5m')) {
    const fiveMinAgo = new Date(now.getTime() - 5 * 60 * 1000);
    params.end_date_min = fiveMinAgo.toISOString();
    params.limit = 10;
  } else if (
    labelLower.includes('hourly') ||
    labelLower.includes('1 hour') ||
    labelLower.includes('1h')
  ) {
    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
    params.end_date_min = oneHourAgo.toISOString();
    params.limit = 10;
  } else if (labelLower.includes('4 hour') || labelLower.includes('4h')) {
    const fourHoursAgo = new Date(now.getTime() - 4 * 60 * 60 * 1000);
    params.end_date_min = fourHoursAgo.toISOString();
    params.limit = 10;
  }
  return params;
};
